<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title
      category="warn"
      title="Missed events"
    />
    <div class="t">Some messages weren't sent automatically because it's already past the date and time that they were scheduled for.</div>
    <div class="m-tx2">
      <div class="t">Cohorts with missed messages:</div>
      <div
        v-for="(date, idx) in state.modal.data.dates"
        :key="`date-${idx}`"
        class="f-ac m-t"
      >
        <div class="dot-sm black m-hx1" />
        <div class="t">{{ date }}</div>
      </div>
    </div>
    <div class="t m-tx2">
      <span>If you would like to send these messages, </span>
      <span class="bold">manually trigger them from each {{ state.onboardingBatches.flowType.primaryRole }}'s calendar</span>
      <span>.</span>
    </div>
    <donut-modal-sections-actions
      button-text="OK"
      :show-cancel="false"
    />
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';

  const { state } = useStore();
</script>
